/** Cross-zone calendar gestures require editor confirmation before mutation. */
export function requiresCrossZoneGestureConfirmation(
  originalDisplayZone: string,
  targetDisplayZone: string,
): boolean {
  return originalDisplayZone !== targetDisplayZone;
}
